import React from 'react';
import '../../assets/styles/StepTwo.css';
import learnImg from '../../assets/images/ARISE WEBSITE_how-08.webp';
import practiceImg from '../../assets/images/ARISE WEBSITE_how-09.webp';
import certifyImg from '../../assets/images/ARISE WEBSITE_how-10.png';
import recognisedImg from '../../assets/images/ARISE WEBSITE_how-11.webp';
import createTeam from '../../assets/images/Createteam.jpg';
import Pitch from '../../assets/images/Pitch.jpg';
import Grant from '../../assets/images/WinGrant.jpg';

const StepThree = () => {
  return (
    <div className="step-two-wrapper font-regular">
      <div className="step-two-header font-bold">
        <h2>Step 3: Pitch and win</h2>
        
         <div className="esb-help-separator"></div>
        {/* <p>
          <span className="step-accent">Learn, Practice, Certify:</span> Gain the skills and
          credibility to take your idea forward.
        </p> */}
      </div>

      <div className="step-two-grid">
        {/* Learn */}
        <div className="step-card">
          <img src={createTeam} alt="Learn" />
          <h3><span className="highlight">Create your team:</span></h3>
          <p>
            Collaborate with peers to build a successful startup.
          </p>
        </div>

        {/* Practice */}
        <div className="step-card">
          <img src={Pitch} alt="Practice" />
          <h3><span className="highlight">Pitch your idea:</span></h3>
          <p>
           Present your business concept to expert judges for feedback.
          </p>
        </div>

    

        {/* Get Recognised */}
        <div className="step-card">
          <img src={Grant} alt="Get Recognised" />
          <h3><span className="highlight">Win the grant:</span></h3>
          <p>
           Compete to win the grant to launch and scale your venture.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepThree;
